import { render, staticRenderFns } from "./PartnerOrdersConfirmModal.vue?vue&type=template&id=39a22a56&"
import script from "./PartnerOrdersConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PartnerOrdersConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./PartnerOrdersConfirmModal.vue?vue&type=style&index=0&id=39a22a56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports